import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    standalone: false
})
export class ErrorComponent implements OnInit {

  @Input('hasLogo') hasLogo: boolean = true
  @Input('hasReturn') hasReturn: boolean = true

  @Input('title') title: string
  @Input('description') description: string

  constructor() {
    //set default values
    this.hasLogo = true;
    this.hasReturn = true;

    this.title = this.title || "Página Inexistente";
    this.description = this.description || "A página solicitada não existe, por favor tente outro caminho."
  }

  ngOnInit(): void {
  }

}
